<form [formGroup]="filterFormGroup">
  <div class="flex-grow">
    <div class="filter-elements">
      <!-- Netzbetreiber -->
      @if (isWetznetzUser) {
        <mat-form-field>
          <mat-label>Netzbetreibername</mat-label>
          <input matInput
            [matAutocomplete]="netzbetreiber"
            data-qa="filter-netzbetreiber-name"
            data-group="list-erzeugungsanlage-filter"
            formControlName="netzbetreiber">
          <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
          <mat-autocomplete #netzbetreiber="matAutocomplete"
            panelWidth="200">
            @for (netzbetreiberName of filteredNetzbetreiber$ | async; track netzbetreiberName) {
              <mat-option
                [value]="netzbetreiberName">
                {{ netzbetreiberName }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- Teilgebiet -->
      @if (isWetznetzUser) {
        <mat-form-field>
          <mat-label>Teilgebiet</mat-label>
          <input matInput
            [matAutocomplete]="teilgebiet"
            data-qa="filter-netzbetreiber-teilgebiet"
            data-group="list-erzeugungsanlage-filter"
            formControlName="teilgebiet">
          <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
          <mat-autocomplete #teilgebiet="matAutocomplete"
            panelWidth="200">
            @for (teilgebiet of filteredTeilgebiete$ | async; track teilgebiet) {
              <mat-option [value]="teilgebiet">
                {{ teilgebiet }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- Dokumenten Id -->
      <mat-form-field>
        <mat-label>Dokumenten-ID</mat-label>
        <input matInput
          [matAutocomplete]="dokumentenId"
          data-qa="filter-dokumenten-id"
          data-group="list-erzeugungsanlage-filter"
          formControlName="dokumentenId">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #dokumentenId="matAutocomplete" panelWidth="200">
          @for (id of filteredDokumentenId$ | async; track id) {
            <mat-option
              [value]="id">
              <div class="anlagentype-option">
                <span>{{ id }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Steuerbare Resource Id -->
      <mat-form-field>
        <mat-label>SR-ID</mat-label>
        <input matInput
          [matAutocomplete]="steuerbareResourceId"
          data-qa="filter-steuerbare-resource-id"
          data-group="list-erzeugungsanlage-filter"
          formControlName="steuerbareResourceId">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #steuerbareResourceId="matAutocomplete" panelWidth="200">
          @for (id of filteredSteuerbareResourceId$ | async; track id) {
            <mat-option [value]="id">
              <div class="steuerbare-resource-id-option">
                <span>{{ id }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Technische Resource Id -->
      <mat-form-field>
        <mat-label>TR-ID</mat-label>
        <input matInput
          [matAutocomplete]="technischeResourceId"
          data-qa="filter-technische-resource-id"
          data-group="list-erzeugungsanlage-filter"
          formControlName="technischeResourceId">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #technischeResourceId="matAutocomplete" panelWidth="200">
          @for (id of filteredTechnischeResourceId$ | async; track id) {
            <mat-option [value]="id">
              <div class="technische-resource-id-option">
                <span>{{ id }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Bezeichnung VNB intern -->
      <mat-form-field>
        <mat-label>Bezeichnung VNB intern</mat-label>
        <input matInput
          [matAutocomplete]="bezVnbIntern"
          data-qa="filter-bez-vnb-intern"
          data-group="list-erzeugungsanlage-filter"
          formControlName="bezVnbIntern">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #bezVnbIntern="matAutocomplete" panelWidth="200">
          @for (bezeichnung of filteredBezVnbIntern$ | async; track bezeichnung) {
            <mat-option [value]="bezeichnung">
              <div class="bez-vnb-intern-option">
                <span>{{ bezeichnung }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Ortsname -->
      <mat-form-field>
        <mat-label>Ortsname</mat-label>
        <input matInput
          [matAutocomplete]="ortsname"
          data-qa="filter-ortsname"
          data-group="list-erzeugungsanlage-filter"
          formControlName="ortsname">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #ortsname="matAutocomplete" panelWidth="200">
          @for (ortsname of filteredOrtsnamen$ | async; track ortsname) {
            <mat-option [value]="ortsname">
              {{ ortsname }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Stationsname -->
      <mat-form-field>
        <mat-label>Stationsname</mat-label>
        <input matInput
          name="stationsname"
          [matAutocomplete]="stationsname"
          data-qa="filter-stationsname"
          data-group="list-erzeugungsanlage-filter"
          formControlName="stationsname">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #stationsname="matAutocomplete" panelWidth="200">
          @for (stationsname of filteredStationsnamen$ | async; track stationsname) {
            <mat-option [value]="stationsname">
              {{ stationsname }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- TrafoFeldName -->
      <mat-form-field>
        <mat-label>Trafo/Feldnummer</mat-label>
        <input matInput
          name="trafoFeldName"
          [matAutocomplete]="trafoFeldName"
          data-qa="filter-trafo-feld-name"
          data-group="list-erzeugungsanlage-filter"
          formControlName="trafoFeldName">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #trafoFeldName="matAutocomplete" panelWidth="200">
          @for (trafoFeldName of filteredTrafoFeldName$ | async; track trafoFeldName) {
            <mat-option [value]="trafoFeldName">
              {{ trafoFeldName }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Status -->
      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select
          data-qa="filter-status"
          data-group="list-erzeugungsanlage-filter"
          formControlName="status">
          <mat-option [value]="true">Gültig</mat-option>
          <mat-option [value]="false">Ungültig</mat-option>
        </mat-select>
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
      </mat-form-field>

      <!-- Energietraeger -->
      <mat-form-field>
        <mat-label>Energieträger</mat-label>
        <input matInput
          name="energietraeger"
          [matAutocomplete]="energietraeger"
          data-qa="filter-energietraeger"
          data-group="list-erzeugungsanlage-filter"
          formControlName="energietraeger">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #energietraeger="matAutocomplete" panelWidth="200"
          [displayWith]="energietraegerPipe.transform">
          @for (energietraeger of Energietraeger | keyvalue; track energietraeger.key) {
            <mat-option [value]="energietraeger.value">
              {{ energietraeger.value | energietraeger }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Bruttonennleistung -->
        <mat-form-field>
            <mat-label>Installierte Leistung Min</mat-label>
            <input matInput
                   formControlName="installierteLeistungMin"
                   type="number"
                   data-group="list-erzeugungsanlage-filter"
                   data-qa="filter-installierte-leistung-min">
            <span matSuffix class="kw-suffix">kW</span>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Installierte Leistung Max</mat-label>
            <input matInput
                   formControlName="installierteLeistungMax"
                   type="number"
                   data-group="list-erzeugungsanlage-filter"
                   data-qa="filter-installierte-leistung-max">
            <span matSuffix class="kw-suffix">kW</span>
        </mat-form-field>
    </div>
  </div>

  <div class="reset-button-container">
      <button matButton="filled" type="reset">
          <mat-icon>autorenew</mat-icon>
          Zurücksetzen
      </button>
    @if (isWetznetzUser) {
        <button id="exportCsvButton" matButton="outlined"
                (click)="exportErzeugungsanlagenCSV()">
            <mat-icon>file_download</mat-icon>
            CSV exportieren
        </button>
    }
  </div>
</form>

